export default __webpack_public_path__ + "static/media/clinocta-icon.7d1f1306.svg";